import script from "./school.vue?vue&type=script&setup=true&lang=js"
export * from "./school.vue?vue&type=script&setup=true&lang=js"

import "./school.vue?vue&type=style&index=0&id=33ba0b1f&lang=less"
import "./school.vue?vue&type=style&index=1&id=33ba0b1f&lang=less&scoped=true"
script.__scopeId = "data-v-33ba0b1f"

export default script